// File: src/views/Opportunity.js

import React from 'react';
import styles from './Opportunity.module.css';
import OpportunityHero from '../components/opportunity/OpportunityHero';
import MarketInfographic from '../components/opportunity/MarketInfographic';

const INFOGRAPHICS = [
  {
    id: 'waste-problem',
    eyebrow: 'The Problem',
    heading: 'The Hidden Costs of Current Waste & Agricultural Practices',
    subheading:
      'Landfills, long-haul transport, and chemical fertilizers are creating compounding environmental and economic damage — damage that GreenScience is uniquely positioned to reverse.',
    image: '/images/current-waste-agricultural-practices.png',
    alt: 'Infographic showing the hidden costs of current waste and agricultural practices including landfill degradation, inefficient logistics, environmental toxicity, and soil nutrient stripping',
    bg: 'light',
    landscape: false,
  },
  {
    id: 'waste-market',
    eyebrow: 'Market Opportunity #1',
    heading: 'The Gold in Green: Mapping the $37 Billion Organic Waste Opportunity',
    subheading:
      'The organic waste management industry is shifting from a disposal-based model to a high-value resource recovery market — driven by strict landfill bans, circular economy principles, and surging demand across commercial, municipal, agricultural, and industrial sectors.',
    image: '/images/organic-waste-market-opportunity.png',
    alt: 'Infographic mapping the $37 billion organic waste market opportunity from 2024 to 2034, showing 7.91% CAGR and strategic segments including commercial, agriculture, municipal, and industrial',
    bg: 'secondary',
    landscape: false,
  },
  {
    id: 'fertilizer-market',
    eyebrow: 'Market Opportunity #2',
    heading: 'Global Organic Fertilizer Market: 2025–2034 Outlook',
    subheading:
      'Regulatory pressure, rising organic food demand, and widespread soil health degradation are driving a decade of high-impact growth in the organic fertilizer sector — the exact market GreenScience\'s premium worm castings are positioned to serve.',
    image: '/images/organic-fertilizer-market-opportunity.png',
    alt: 'Infographic showing the global organic fertilizer market outlook from 2025 to 2034, growing from USD 7.71 billion to USD 16.6 billion at a 9.02% CAGR',
    bg: 'light',
    landscape: false,
  },
];

function Opportunity() {
  return (
    <div className={styles.page}>
      <OpportunityHero />
      {INFOGRAPHICS.map((item) => (
        <MarketInfographic key={item.id} {...item} />
      ))}
    </div>
  );
}

export default Opportunity;